import React from "react";
import CommonStatCard from "../../pt/pt-flow-new/CommonStatCard";
import { convertThenFormat } from "../../common-data/Converts";

const PettyCashStats = ({ allStats, onCardClick, selectedStatus }) => {
  const pettyCashStats = [
    {
      label: "Total Petty Cash Paid",
      count: allStats?.paid_requests_count || 0,
      amount: allStats?.total_petty_cash_paid || 0,
      field: "total_petty_cash_paid",
      color: "#10b981", // Green for completed
    },
    {
      label: "Total Petty Cash Pending",
      count: allStats?.pending_requests_count || 0,
      amount: allStats?.total_petty_cash_pending || 0,
      field: "total_petty_cash_pending",
      color: "#f59e0b", // Orange for pending
    },
    {
      label: "Total Petty Cash Rejected",
      count: allStats?.rejected_requests_count || 0,
      amount: allStats?.total_petty_cash_rejected || 0,
      field: "total_petty_cash_rejected",
      color: "#ef4444", // Red for rejected
    },
    {
      label: "Total Petty Cash Requested",
      count: allStats?.total_requests_count || 0,
      amount: allStats?.total_petty_cash_requested || 0,
      field: "total_petty_cash_requested",
      color: "#3b82f6", // Blue for total
    },
  ];

  const handleCardClick = (fieldName) => {
    if (onCardClick) {
      onCardClick(fieldName);
    }
  };

  const getCardData = (stat) => {
    return {
      total_amount: parseInt(stat.amount || 0),
      count: parseInt(stat.count || 0),
    };
  };

  // Check if card is selected
  const isSelected = (fieldName) => {
    if (!selectedStatus) return false;
    return fieldName === selectedStatus;
  };

  const cardStyle = {
    position: "relative",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: "3px solid #209216",
    borderRadius: "8px",
    backgroundColor: "rgba(32, 146, 22, 0.1)",
    pointerEvents: "none",
    zIndex: 1,
  };

  const checkmarkStyle = {
    position: "absolute",
    top: "8px",
    right: "8px",
    backgroundColor: "#209216",
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    zIndex: 2,
  };

  return (
    <div className="cards-container cards-grid-container grid-expense-stats pt-flow-new">
      {pettyCashStats.map((stat) => {
        const data = getCardData(stat);
        const selected = isSelected(stat?.field);

        return (
          <div key={stat?.field} style={cardStyle}>
            <CommonStatCard
              tagName={stat?.field}
              cardLabel={
                <>
                  {stat.label} (
                  <span
                    style={{
                      color: stat.color,
                      fontSize: "24px",
                      fontWeight: "700",
                      backgroundColor: `${stat.color}20`,
                      padding: "1px 4px",
                      borderRadius: "12px",
                    }}
                  >
                    {data?.count}
                  </span>
                  )
                </>
              }
              value={`₹${convertThenFormat(data?.total_amount)}`}
              onClickCard={handleCardClick}
            />
            {selected && <div style={overlayStyle} />}
            {selected && <div style={checkmarkStyle}>✓</div>}
          </div>
        );
      })}
    </div>
  );
};

export default PettyCashStats;
